module.exports = __webpack_public_path__ + "static/media/phone.bc2a5563.png";